import { DirectorySortOrder } from './directory-sort-order.enum';
import { AcademicSession } from '../util/academic-session.model';
import { WardGroupType } from './ward-group-type.model';
import { WardGroup } from './ward-group.model';
import { Gender } from './gender.enum';

/**
 * What the user can pick when generating an administrative or ward member directory.
 */
export class WardDirectoryParameters {
  includePhoto: boolean;
  includePreferredName: boolean;
  includeFullName: boolean;
  includeBirthdate: boolean;
  includeSchoolAddress: boolean;
  includeByuiEmail: boolean;
  includeTrack: boolean;
  includeCellPhone: boolean;
  includeHomeTown: boolean;
  includeMission: boolean;
  includeReturnedMissionary: boolean;
  includeHomeUnit: boolean;

  gender: string;
  session: AcademicSession;
  wardGroupType: WardGroupType;
  wardGroup: WardGroup;

  sortBy: DirectorySortOrder;

  constructor() {
    this.sortBy = DirectorySortOrder.Address;
    this.gender = Gender.All;
    this.includePhoto = true;
    this.includePreferredName = true;
    this.includeFullName = true;
    this.includeBirthdate = true;
    this.includeSchoolAddress = true;
    this.includeByuiEmail = true;
    this.includeTrack = true;
    this.includeCellPhone = true;
    this.includeHomeTown = true;
    this.includeMission = true;
    this.includeReturnedMissionary = true;
    this.includeHomeUnit = true;
  }
}
